import React from 'react';
import debounce from 'lodash/debounce';

class DebouncedInputField extends React.Component {
  static defaultProps = {
    value: '',
    onChange: () => {}
  };

  state = {
    value: this.props.value,
    lastDebouncedValue: this.props.value || '',
    isDebouncing: false
  };

  componentWillMount() {
    if (__DEV__) {
      // eslint-disable-next-line no-console
      console.warn(
        'DebouncedInputField is deprecated. Use Debounced with <input type="text" /> instead.'
      );
    }
    // Have to create the debounced function here instead of specifying it as
    // a separate field in order for the debounced function to be generated
    // separately for each component instance.
    this._scheduleChange = debounce(() => this._commitChange(), 1000);
  }

  componentWillReceiveProps(nextProps) {
    if (!this.state.isDebouncing) {
      this.setState({
        value: nextProps.value,
        lastDebouncedValue: nextProps.value
      });
    }
  }

  componentWillUnmount() {
    this._scheduleChange.cancel();
  }

  render() {
    return (
      <input
        {...this.props}
        type="text"
        value={this.state.value}
        onChange={this._handleChange}
        onBlur={this._handleBlur}
      />
    );
  }

  _handleChange = evt => {
    this.setState({
      value: evt.target.value
    });

    this.setState({ isDebouncing: true });
    this._scheduleChange();
  };

  _handleBlur = () => {
    this._commitChange();
  };

  _commitChange = () => {
    if (this.state.lastDebouncedValue !== this.state.value) {
      this.setState({ lastDebouncedValue: this.state.value });
      this.props.onChange(this.state.value);
    }
    this.setState({ isDebouncing: false });
  };
}

export default DebouncedInputField;
